// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"042bbbbd","85":"3c929fbb","134":"19d715e9","341":"86b5d12f","353":"37c7c79e","496":"88cafd31","552":"0acd36d6","860":"5d3c6131","957":"9ad6ea77"}[chunkId] + ".chunk.js";
};